"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var storybook_1 = require("@eyecons/storybook");
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function FormFields(_a) {
    var chapter = _a.chapter, setChapter = _a.setChapter, pointerTime = _a.pointerTime, videoLength = _a.videoLength;
    react_1.useEffect(function () {
        if (chapter.start_seconds > 0) {
            setChapter({ start_seconds: chapter.start_seconds });
            return false;
        }
        setTime('start', pointerTime);
    }, [pointerTime]);
    function setTime(type, seconds) {
        if (storybook_1.Helpers.HHMMSSToSeconds(seconds) > videoLength) {
            seconds = videoLength;
        }
        type === 'start'
            ? setChapter({ start_seconds: storybook_1.Helpers.HHMMSSToSeconds(seconds) })
            : setChapter({ end_seconds: storybook_1.Helpers.HHMMSSToSeconds(seconds) });
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Input, { name: 'title', value: chapter.title, placeholder: 'Titel van het hoofdstuk', onChange: function (title) { return setChapter({ title: title }); } })),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement("label", { className: 'mb-2 block', htmlFor: 'start_seconds' }, "Begin hoofdstuk"),
            react_1.default.createElement(storybook_1.Forms.Input, { type: 'time', step: '1', name: 'start_seconds', value: storybook_1.Helpers.toHHMMSS(chapter.start_seconds), placeholder: 'Start seconds', onChange: function (start_seconds) { return setTime('start', start_seconds); } })));
}
exports.default = FormFields;
FormFields.propTypes = {
    /**
     * The Chapter
     */
    chapter: prop_types_1.default.shape({
        title: prop_types_1.default.string,
        start_seconds: prop_types_1.default.number,
        end_seconds: prop_types_1.default.number,
    }),
    /**
     * Set the Chapter
     */
    setChapter: prop_types_1.default.func,
};
FormFields.defaultProps = {};
